import { combineReducers } from 'redux';
import { users } from './users';

export default combineReducers({
    users
})



// WEBPACK FOOTER //
// ./src/reducers/index.js